/**
 * Video Popup Controller
 * 点击 .joint-video-item 显示对应视频弹窗
 * 点击 .video-close-window 关闭视频弹窗
 */

document.addEventListener('DOMContentLoaded', function () {
    const videoItems = document.querySelectorAll('.joint-video-item');
    const videoPopups = document.querySelectorAll('.video-pop-up-window');

    // 点击视频封面显示对应弹窗
    videoItems.forEach(function (item) {
        item.addEventListener('click', function () {
            const index = this.getAttribute('index');
            const targetPopup = document.querySelector(`.video-pop-up-window[index="${index}"]`);

            if (targetPopup) {
                // 移除所有弹窗的 active 类
                videoPopups.forEach(function (popup) {
                    popup.classList.remove('active');
                    // 暂停所有视频
                    const video = popup.querySelector('video');
                    if (video) {
                        video.pause();
                        video.currentTime = 0;
                    }
                });

                // 添加 active 类到目标弹窗
                targetPopup.classList.add('active');

                // 播放视频
                const targetVideo = targetPopup.querySelector('video');
                if (targetVideo) {
                    targetVideo.play();
                }
            }
        });
    });

    // 点击关闭按钮关闭弹窗
    const closeButtons = document.querySelectorAll('.video-close-window');
    closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.stopPropagation();

            const popup = this.closest('.video-pop-up-window');
            if (popup) {
                popup.classList.remove('active');

                // 暂停视频
                const video = popup.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        });
    });

    // 点击弹窗背景区域关闭
    videoPopups.forEach(function (popup) {
        popup.addEventListener('click', function (e) {
            // 只有点击的是弹窗本身（不是视频或按钮）才关闭
            if (e.target === popup) {
                popup.classList.remove('active');

                const video = popup.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        });
    });

    // ESC 键关闭弹窗
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            videoPopups.forEach(function (popup) {
                if (popup.classList.contains('active')) {
                    popup.classList.remove('active');

                    const video = popup.querySelector('video');
                    if (video) {
                        video.pause();
                        video.currentTime = 0;
                    }
                }
            });
        }
    });
});